// Standard shadcn `cn()` helper: merge clsx output through tailwind-merge
// so conflicting Tailwind utility classes resolve to the LAST one (e.g.
// `cn("p-2", isActive && "p-4")` -> "p-4" instead of both classes).
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}


/**
 * Locale-aware natural-sort collator. Use anywhere a list of
 * donor/sample/cluster labels is shown to humans -- naive lex sort
 * leaks "HD1 HD10 HD2 HD3" / "0 1 10 2 3" which trips everyone up.
 *
 * Examples:
 *   ["HD1","HD10","HD2"].sort(naturalCompare) -> ["HD1","HD2","HD10"]
 *   ["0","1","10","2"].sort(naturalCompare)   -> ["0","1","2","10"]
 */
const _NATURAL_COLLATOR = new Intl.Collator(undefined, {
  numeric: true, sensitivity: "base",
});
export const naturalCompare = (a: string, b: string) =>
  _NATURAL_COLLATOR.compare(a, b);

/** Sort a list naturally by the value of `key(item)`. Returns a new array. */
export function naturalSortBy<T>(items: readonly T[], key: (t: T) => string): T[] {
  return [...items].sort((a, b) => naturalCompare(key(a), key(b)));
}
